// extracted by mini-css-extract-plugin
module.exports = {"layer":"_2787e5dfdf--layer--22Nn8","icon":"_2787e5dfdf--icon--3MkwY","large":"_2787e5dfdf--large--1t_-B","extra-large":"_2787e5dfdf--extra-large--3cb7z"};